import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import iView  from 'view-design';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'view-design/dist/styles/iview.css';
import './assets/weui.css';
import VueWechatTitle from 'vue-wechat-title' 
import Vant from 'vant';
import 'vant/lib/index.css';
import scroll from 'vue-seamless-scroll'
import VueLuckyCanvas from '@lucky-canvas/vue';
import VueReport from 'vue-report'


Vue.use(VueLuckyCanvas);
Vue.use(iView);
Vue.use(scroll)
Vue.use(VueWechatTitle);
Vue.use(Vant);
Vue.use(VueReport);
Vue.prototype.axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: 'small'
});


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
      document.title = to.meta.title;
  }
  next();
})
